import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';
import { useFlags, useService } from '@mint-lib/routing-context';
import { CampaignManagerIntegrations } from '@mint-sdk/api-integrations';

import { CmIntegrationsResponseSchema } from '../../schemas/integrations.js';

const getIntegrations = async () => {
  const { data } = await api.get('/api/campaign_manager/v2/integrations/');
  return CmIntegrationsResponseSchema.parse(data);
};

export const useGetCampaignManagerIntegrations = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const ff = useFlags('@mint/arm', ['integrationsQuerySdk']);
  const isIntegrationSdkEnabled = ff?.integrationsQuerySdk?.enabled;

  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading } = useQuery({
    queryKey: ['campaign_manager'],
    queryFn: getIntegrations,
    enabled: enabled && !isIntegrationSdkEnabled,
  });

  const {
    data: campaignManagerIntegrations,
    isLoading: campaignManagerLoading,
  } = useQuery(
    {
      ...CampaignManagerIntegrations.getQueryOptions({}),
      enabled: enabled && isIntegrationSdkEnabled,
    },
    queryClient,
  );

  if (isIntegrationSdkEnabled) {
    return {
      data: campaignManagerIntegrations,
      isLoading: campaignManagerLoading,
    };
  }

  return {
    data,
    isLoading,
  };
};
